import React, { useState } from 'react';

/**
 * Collapsible filter shell (MatchupFilters pattern) for mobile-friendly admin panels.
 */
export default function CollapsibleFilterPanel({
  summary = null,
  hasActiveFilters = false,
  ariaLabel = 'Filters',
  defaultExpanded = false,
  children,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div
      className="mb-4 overflow-hidden rounded-xl border border-border-light bg-surface-subtle/60 sm:mb-6"
      aria-label={ariaLabel}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left transition-colors hover:bg-surface-subtle sm:px-4 sm:py-3"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        <div className="min-w-0 flex-1">
          <span className="text-[10px] font-bold uppercase tracking-wider text-text-muted sm:text-xs">
            Filters
          </span>
          {!expanded && summary ? (
            <p className="mt-0.5 truncate text-xs text-text-secondary">{summary}</p>
          ) : null}
          {!expanded && !summary && hasActiveFilters ? (
            <p className="mt-0.5 text-xs text-text-secondary">Active</p>
          ) : null}
        </div>
        <div className="flex shrink-0 items-center gap-2">
          {hasActiveFilters && !expanded ? (
            <span className="rounded bg-primary/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary">
              On
            </span>
          ) : null}
          <svg
            className={`h-5 w-5 text-text-muted transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>

      <div
        className={`overflow-hidden transition-all duration-200 ease-in-out ${
          expanded ? 'max-h-[520px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="border-t border-border-light px-3 py-3 sm:px-4 sm:py-4">{children}</div>
      </div>
    </div>
  );
}

function FilterField({ id, label, labelShort, children }) {
  return (
    <div className="min-w-0">
      <label htmlFor={id} className="mb-1 block text-xs font-medium text-text-secondary">
        <span className="sm:hidden">{labelShort ?? label}</span>
        <span className="hidden sm:inline">{label}</span>
      </label>
      {children}
    </div>
  );
}

export { FilterField };
